var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg_slider",style:({ 'background-position': '-' + _vm.percentProgression + '% ' + '100%' }),on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }